module.exports = __webpack_public_path__ + "static/media/logo.d16b9b10.svg";